module.exports = __webpack_public_path__ + "static/media/iGive2_logo.c9e9db12.png";